import { END_POINT } from "../constants/api.constants";
import { store } from "../store";

const {
  PROMO_CODE_CHECK,
} = END_POINT;

export const checkPromoCodeAPI = async (payload) => {
  return await fetch(PROMO_CODE_CHECK, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};